import { takeEvery, all, call, SagaReturnType } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { login } from 'api/auth';
import { AuthInfo, loginAction, logoutAction, setAuthInfoAction, } from 'store/auth/auth.actions';
import { AUTH_TOKEN, REFRESH_TOKEN, clearLocalState, writeToLocalState } from 'utils/localStorage';

function* loginFlow(action: typeof loginAction.types.triggerAction) {
  try {
    const {
      data,
    }: SagaReturnType<typeof login> = yield call(login, action.payload)
    yield call(loginAction.sagas.resolve, action, data)
  } catch (e: any) {
    yield call(loginAction.sagas.reject, action, e?.response?.data || e)
  }
}

function setAuthInfoFlow({payload}: PayloadAction<AuthInfo>) {
  writeToLocalState(AUTH_TOKEN, payload.token);
  if (payload.refreshToken) {
    writeToLocalState(REFRESH_TOKEN, payload.refreshToken);
  }
}

function logoutFlow() {
  clearLocalState(AUTH_TOKEN);
  clearLocalState(REFRESH_TOKEN);
}

export default function* authSaga() {
  yield all([
    takeEvery(loginAction.trigger, loginFlow),
    takeEvery([loginAction.resolved, setAuthInfoAction], setAuthInfoFlow),
    takeEvery(logoutAction, logoutFlow)
  ]);
}
